
























































import {Vue, Component, Watch} from 'vue-property-decorator';
import dataProxy from "@/services/data-proxy.service";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {formatDate} from "@/utils/formatters";

declare const $ : any;

@Component({})
export default class EvidencijaRadnogVremena extends mixins(ComponentBaseMixin) {
    godine = [];
    meseci = [];
    selectedMonth = 1;
    selectedYear = new Date().getFullYear();
    vozacId: number = null;
    mestoTroska?: number = null;
    select2Options = {
        minimumResultsForSearch: Infinity
    };
    isBusy = false;
    isPrinting = false;
    dnevnaRadnaVremena = [];
    tableColumns = [];
    tableOptions = {
        search: true,
        pagination: true,
        showColumns: true,
        headerStyle: () => {return {css: {'font-size': '9px'}}}
    };
    pdfUrl: string = null;

    async created() {
        this.godineIMeseciOptions();
        this.tableColumns = [
            {field: 'imeIPrezime', title: this.$i18n.t('osoba'), width: 160},
            {field: 'datum', title: this.$i18n.t('datum'), width: 50, formatter: formatDate},
            {field: 'pocetakRV', title: this.$i18n.t('pocetakRV'), width: 50, formatter: formatDate},
            {field: 'krajRV', title: this.$i18n.t('krajRV'), width: 50, formatter: formatDate},
            {field: 'trajanjeRVFormatted', title: this.$i18n.t('trajanjeRV'), width: 30},
            {field: 'vremeVoznjeFormatted', title: this.$i18n.t('vremeVoznje'), width: 30},
            {field: 'ostaloRVFormatted', title: this.$i18n.t('ostaloRV'),width: 30},
            {field: 'raspolozivoVremeFormatted', title: this.$i18n.t('raspolozivoVreme'),width: 30},
            {field: 'odmorURVFormatted', title: this.$i18n.t('odmorURV'),width: 30},
            {field: 'nocnoRadnoVremeFormatted', title: this.$i18n.t('nocnoRadnoVreme'),width: 30},
            {field: 'placenoOdsustvoFormatted', title: this.$i18n.t('placenoOdsustvo'),width: 30},
        ];

        this.$nextTick(() => (<any>this.$refs.observer).validate());
    }

    async pretraziRadnaVremena() {
        const valid = await (<any>this.$refs.observer).validate();
        if (valid) {
            try {
                this.isBusy = true;
                this.dnevnaRadnaVremena = await this.loadData(() =>
                    dataProxy.vratiDnevnoRadnoVreme(this.selectedYear, this.selectedMonth, this.vozacId, this.mestoTroska))();
            } finally {
                this.isBusy = false;
            }
        }
    }

    godineIMeseciOptions() {
        this.meseci = [
            {value: 1, text: this.$i18n.t('januar')},{value: 2, text: this.$i18n.t('februar')},
            {value: 3, text: this.$i18n.t('mart')},{value: 4, text: this.$i18n.t('april')},
            {value: 5, text: this.$i18n.t('maj')},{value: 6, text: this.$i18n.t('jun')},{value: 7, text: this.$i18n.t('jul')},
            {value: 8, text: this.$i18n.t('avgust')},{value: 9, text: this.$i18n.t('septembar')},
            {value: 10, text: this.$i18n.t('oktobar')},{value: 11, text: this.$i18n.t('novembar')},
            {value: 12, text: this.$i18n.t('decembar')}
        ];
        const now = new Date();
        this.godine = [
            {value: now.getFullYear(), text: now.getFullYear()},
            {value: now.getFullYear() - 1, text: now.getFullYear() - 1},
            {value: now.getFullYear() - 2, text: now.getFullYear() - 2}
        ];
        this.meseci.unshift({value: '', text: '...'});
        this.meseci = this.meseci.map(m => ({id: m.value, text: m.text}));

        this.godine.unshift({value: '', text: '...'});
        this.godine = this.godine.map(g => ({id: g.value, text: g.text}));

    }

    async stampaj() {
        const valid = await (<any>this.$refs.observer).validate();
        if (valid) {
            try {
                this.isPrinting = true;
                const link = await this.loadData(() =>
                    dataProxy.vratiStampuEvidencijeRadnihVremenaVozaca(this.selectedYear, this.selectedMonth, this.vozacId, this.mestoTroska))();
                this.pdfUrl = `${link}?t=${new Date().getUTCMilliseconds()}`
            } finally {
                this.isPrinting = false;
            }
        }
    }
}
